import { getToken, getUser } from "../Utils/Common";
import { postAPICall, putAPICall } from "./axiosMethodCalls";


export const createCategories = async (data, restoType) => {
    try {
        const response = restoType==="hanamaruken" ? await postAPICall(
            process.env.REACT_APP_BRIQUE_API + "categories/create", {
                requester: getUser(),
                token: getToken(),
                name: data.name,
            }
        ) : await postAPICall(
            process.env.REACT_APP_ETTAS_API + "categories/create", {
                requester: getUser(),
                token: getToken(),
                name: data.name,
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

export const updateCategories = async (data, restoType) => {
    try {
        const params = new URLSearchParams();
        params.append('name',data.name)
        params.append('updated_by',getUser())
        params.append('token',getToken())

        const response = restoType==="build" ? await putAPICall(
            process.env.REACT_APP_BRIQUE_API + "categories/update/" + data.id,
            params
        ):await putAPICall(
            process.env.REACT_APP_ETTAS_API + "categories/update/" + data.id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};


//GET
export const deleteCategories = async (id, restoType) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())

        const response = restoType === "hanamaruken" ? await putAPICall(
            process.env.REACT_APP_BRIQUE_API + "categories/delete/" + id,
            params
        ) : await putAPICall(
            process.env.REACT_APP_ETTAS_API + "categories/delete/" + id,
            params
        ) ;
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};